var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideoSetScormPublish = function SvgIconVideoSetScormPublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#icon_video_set_scorm_publish_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.666 6.049h3.382V2.667h4.618V6.39h.89V2.667a.89.89 0 0 0-.89-.89H4.831L1.777 4.832v8.502a.89.89 0 0 0 .89.89h8a.89.89 0 0 0 .888-.89H2.666zm0-.853 2.53-2.53h.137v2.667H2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.586 7.267a.444.444 0 0 0-.627.626l1.445 1.44H7.999a.444.444 0 1 0 0 .89h5.418l-1.458 1.457a.446.446 0 0 0 .127.752.44.44 0 0 0 .5-.125l2.524-2.53z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_video_set_scorm_publish_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconVideoSetScormPublish;